import NoData from "common/customIcons/noData";
import { useTranslation } from "react-i18next";
export const NoDataFound = () => {
    const {t} = useTranslation();
    return (
        <div className='w-full h-1/3  flex flex-col justify-center items-center'>
            <div className="w-20 h-20"><NoData /></div>
            <p className='text-[#828282] text-xl text-center capitalize max-w-sm mx-auto mt-4'>{t('monitoring:screenRecords.noData')}</p>
        </div>
    );
};
